export default defineNuxtRouteMiddleware(async (route) => {
  if (import.meta.server) return

  const { navigateToLocalized } = useRouterUtils()
  const { addToast } = useToaster()
  const { t } = useNuxtApp().$i18n

  const orderId = String(route.params.id)
  const drawNumber = Number(route.params.drawNumber)

  const cancel = (showToast = true) => {
    if (showToast) {
      addToast(
        {
          headline: t('highfrequencygame.toast.error.drawparticipation.headline'),
          message: {
            translationKey: 'highfrequencygame.toast.error.drawparticipation.message',
            translationVariables: {
              contactSupport: {
                text: t('common.sentences.contactsupport').toLowerCase(),
                to: '/service?chat=true',
                type: 'link',
              },
            },
          },
          tracking: {
            topicKey: 'hfg-game-watch-error-draw-participation',
          },
          type: 'danger',
        },
        'hfg-game-watch-error-draw-participation',
      )
    }

    return navigateToLocalized(`/my-orders/keno/${orderId}`, { replace: true })
  }

  try {
    const response = await useHighFrequencyDrawParticipationLazyQuery({
      drawNumber,
      orderId,
    }).load()

    if (!response) return cancel()

    const data = response.highFrequencyDrawParticipation
    if (isGraphqlFailure(data)) return cancel()
  } catch {
    return cancel()
  }
})
